/* ---- href prefix layer v3 (2026-09-04, 全店统一轮子) ----
   作用:在本地化路径(/it/、/de-ch/ …)下,把写死的站内链接补上当前语言前缀,点击不丢语言。
   v3 相对 v2:① 绝对链接(https://本站域名/collections/x,带不带 www 都算)也补前缀 ② 永不重复加前缀(按 Shopify.routes.root 判重 + 任何 xx / xx-yy 开头都视为已带语言)
   ③ 页面加载后再补两次(App 晚渲染的菜单)④ 点击时兜底。root 只信 Shopify.routes.root,不猜。 */
(function () {
  if (window.__xHrefFix3) return; window.__xHrefFix3 = 1;
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  if (!ROOT || ROOT === '/') return;
  var P = ROOT.replace(/\/+$/, '');
  var HOST = location.host.toLowerCase().replace(/^www\./, '');
  var SKIP = /^\/(a|cdn|admin|apps|tools|localization|checkout|gift_cards|wpm@|\d+)(\/|$)/;
  function pref(h) {
    if (!h || h.charAt(0) !== '/' || h.charAt(1) === '/') return h;
    var path = h.split(/[?#]/)[0];
    if (SKIP.test(path)) return h;
    if (h === P || h.indexOf(P + '/') === 0 || h.indexOf(P + '?') === 0 || h.indexOf(P + '#') === 0) return h;
    var seg = path.split('/')[1] || '';
    if (/^[a-z]{2}(-[a-z]{2})?$/i.test(seg)) return h;
    return P + h;
  }
  function fix(a) {
    var h = a.getAttribute('href'); if (!h) return;
    if (/^(#|mailto:|tel:|sms:|javascript:)/i.test(h)) return;
    var m = h.match(/^(?:https?:)?\/\/([^\/?#]+)(.*)$/i);
    if (m) {
      if (m[1].toLowerCase().replace(/^www\./, '') !== HOST) return;
      var rest = m[2] || '/'; if (rest.charAt(0) !== '/') rest = '/' + rest;
      var n = pref(rest); if (n !== rest) a.setAttribute('href', n);
      return;
    }
    if (h.charAt(0) !== '/') return;
    var n2 = pref(h); if (n2 !== h) a.setAttribute('href', n2);
  }
  function fixAll() { var as = document.querySelectorAll('a[href]'); for (var i = 0; i < as.length; i++) fix(as[i]); }
  if (document.readyState !== 'loading') fixAll(); else document.addEventListener('DOMContentLoaded', fixAll);
  window.addEventListener('load', function () { fixAll(); setTimeout(fixAll, 1500); setTimeout(fixAll, 4000); });
  document.addEventListener('click', function (e) { var a = e.target && e.target.closest && e.target.closest('a[href]'); if (a) fix(a); }, true);
})();
